// extracted by mini-css-extract-plugin
export default {"cardContent":"ACard_cardContent__vS5FW","actionsContainer":"ACard_actionsContainer__BVTye"};